module.exports = __webpack_public_path__ + "static/media/icon_143.1f65fed9.svg";